/* JAQUAN CHANGE: "Save" bookmark button on product photos (snippets/bf-save-icon.liquid).
   Tap = send a "Saved Product" event to Klaviyo (same event and properties as
   "Email me this part", snippets/bf-save-part.liquid), so the saved-part flow
   emails the part. First time: a small window asks for an email. The email and
   the saved parts are remembered in this browser, so later taps save in one go.
   Tapping a saved part un-saves it here (no email is sent for that).
   No animations. */
(function () {
  'use strict';
  if (window.BFSaveIcon) return;

  var SAVED_KEY = 'bf_saved_parts';
  var EMAIL_KEY = 'bf_save_email';

  function read(key, fallback) {
    try {
      var v = window.localStorage.getItem(key);
      return v === null ? fallback : JSON.parse(v);
    } catch (e) {
      return fallback;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function savedList() {
    var list = read(SAVED_KEY, []);
    return Array.isArray(list) ? list.map(String) : [];
  }

  function isSaved(id) {
    return savedList().indexOf(String(id)) !== -1;
  }

  function setSaved(id, on) {
    var list = savedList().filter(function (x) {
      return x !== String(id);
    });
    if (on) list.push(String(id));
    write(SAVED_KEY, list.slice(-200));
    paintAll();
  }

  function paint(btn) {
    var data = btn._bfData || parse(btn);
    if (!data) return;
    var on = isSaved(data.productId);
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', (on ? 'Saved: ' : 'Save ') + data.name);
  }

  function paintAll() {
    document.querySelectorAll('[data-bf-saveicon]').forEach(paint);
  }

  function parse(btn) {
    try {
      btn._bfData = JSON.parse(btn.getAttribute('data-bf-saveicon'));
    } catch (e) {
      btn._bfData = null;
    }
    return btn._bfData;
  }

  function validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* ----------------------------- toast ------------------------------ */
  var toast = null;
  var toastTimer = null;
  function say(text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bf-savetoast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.hidden = true;
    }, 4000);
  }

  /* --------------------------- send to Klaviyo --------------------------- */
  function variantFor(btn, data) {
    var id = '';
    var formId = btn.getAttribute('data-form-id');
    var pform = formId ? document.getElementById(formId) : null;
    var field = pform ? pform.querySelector('[name="id"]') : null;
    if (field) id = String(field.value);
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === id) return data.variants[i];
    }
    return data.variants[0];
  }

  function send(btn, data, email) {
    var v = variantFor(btn, data);
    var url = data.url + (data.multi && v ? '?variant=' + v.id : '');
    var props = {
      ProductName: data.name,
      ProductID: data.productId,
      VariantID: v.id,
      VariantName: data.multi ? v.title : '',
      SKU: v.sku,
      Brand: data.vendor,
      Price: v.price,
      CompareAtPrice: v.compare,
      URL: url,
      ImageURL: v.image || data.image,
      Fitment: data.make,
      Trims: data.trim,
      FitmentNotes: data.fitment,
      InstallTime: data.install,
      Shipping: data.shipping,
      SavedFrom: btn.classList.contains('bf-saveicon--page') ? 'Product page' : 'Product card',
      $event_id: 'save-' + v.id + '-' + Date.now()
    };

    function sendDirect() {
      var body = {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            value: v.value,
            unique_id: props.$event_id,
            metric: { data: { type: 'metric', attributes: { name: 'Saved Product' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      };
      return fetch('https://a.klaviyo.com/client/events/?company_id=UbzPDG', {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15'
        },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
      });
    }

    // Klaviyo's own site script first (so the event lands on the right profile), then the direct endpoint.
    function sendViaKlaviyo() {
      var k = window.klaviyo;
      if (!k || typeof k.identify !== 'function' || typeof k.track !== 'function') {
        return Promise.reject(new Error('no klaviyo.js'));
      }
      var trackProps = Object.assign({}, props, { $value: v.value });
      var go = Promise.resolve(k.identify({ email: email })).then(function () {
        return k.track('Saved Product', trackProps);
      }).then(function (ok) {
        if (ok === false) throw new Error('klaviyo.track failed');
      });
      var timeout = new Promise(function (resolve, reject) {
        setTimeout(function () {
          reject(new Error('klaviyo.js timed out'));
        }, 6000);
      });
      return Promise.race([go, timeout]);
    }

    return sendViaKlaviyo().catch(function (err) {
      if (window.console) console.warn('[bf-save-icon]', err && err.message, '- trying direct send');
      return sendDirect();
    });
  }

  /* ----------------------------- email window ----------------------------- */
  var dialog = null;
  var pending = null;
  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'bf-savedlg';
    dialog.setAttribute('aria-labelledby', 'BfSaveDlgTitle');
    dialog.innerHTML =
      '<form class="bf-savedlg__panel" method="dialog" novalidate>' +
      '<button type="button" class="bf-savedlg__close" data-bf-savedlg-close aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg></button>' +
      '<p class="bf-savedlg__title" id="BfSaveDlgTitle">Save this part</p>' +
      '<p class="bf-savedlg__part" data-bf-savedlg-part></p>' +
      '<label class="bf-savedlg__label" for="BfSaveDlgEmail">Your email</label>' +
      '<input class="bf-savedlg__input" id="BfSaveDlgEmail" type="email" autocomplete="email" inputmode="email" placeholder="you@example.com" required>' +
      '<button type="submit" class="bf-savedlg__btn">Save part</button>' +
      '<p class="bf-savedlg__note">We’ll email you this part with the fitment and price, plus one reminder. No spam.</p>' +
      '<p class="bf-savedlg__msg" role="status" aria-live="polite" data-bf-savedlg-msg></p>' +
      '</form>';
    document.body.appendChild(dialog);

    var form = dialog.querySelector('form');
    var input = dialog.querySelector('input');
    var submit = dialog.querySelector('.bf-savedlg__btn');
    var msg = dialog.querySelector('[data-bf-savedlg-msg]');

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-bf-savedlg-close]')) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (pending && pending.btn) pending.btn.focus();
      pending = null;
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!pending) return;
      var email = input.value.trim();
      if (!validEmail(email)) {
        msg.textContent = 'Please enter a valid email.';
        input.focus();
        return;
      }
      var job = pending;
      submit.disabled = true;
      msg.textContent = '';
      send(job.btn, job.data, email)
        .then(function () {
          write(EMAIL_KEY, email);
          setSaved(job.data.productId, true);
          dialog.close();
          say('Saved. We\u2019ll email you this part.');
        })
        .catch(function () {
          msg.textContent = 'That didn’t go through. Please try again.';
        })
        .then(function () {
          submit.disabled = false;
        });
    });
  }

  function askEmail(btn, data) {
    if (!dialog) buildDialog();
    pending = { btn: btn, data: data };
    dialog.querySelector('[data-bf-savedlg-part]').textContent = data.name;
    dialog.querySelector('[data-bf-savedlg-msg]').textContent = '';
    var input = dialog.querySelector('input');
    input.value = btn.getAttribute('data-email') || '';
    document.documentElement.style.overflow = 'hidden';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    input.focus();
  }

  /* ------------------------------- taps -------------------------------- */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-bf-saveicon]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var data = btn._bfData || parse(btn);
      if (!data || !data.variants || !data.variants.length) return;

      if (isSaved(data.productId)) {
        setSaved(data.productId, false);
        say('Removed from your saved parts.');
        return;
      }

      var email = read(EMAIL_KEY, '') || btn.getAttribute('data-email') || '';
      if (!validEmail(email)) {
        askEmail(btn, data);
        return;
      }
      btn.disabled = true;
      send(btn, data, email)
        .then(function () {
          write(EMAIL_KEY, email);
          setSaved(data.productId, true);
          say('Saved. We\u2019ll email you this part.');
        })
        .catch(function () {
          say('That didn’t go through. Please try again.');
        })
        .then(function () {
          btn.disabled = false;
        });
    },
    true
  );

  // "Email me this part" under Add to cart also counts as saving.
  document.addEventListener('bf:part-saved', function (e) {
    var d = e.detail || {};
    if (d.email && validEmail(d.email)) write(EMAIL_KEY, d.email);
    if (d.productId) setSaved(d.productId, true);
  });

  // Cards added later (filters, infinite scroll, recommendations) get painted too.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      paintAll();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) {
    if (e.key === SAVED_KEY) paintAll();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintAll);
  else paintAll();

  window.BFSaveIcon = { refresh: paintAll };
})();
